export default __webpack_public_path__ + "static/3-6bd954ba6aed381236bc08f1b1edd965.jpg";